import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    button: {
        '&.MuiIconButton-root': {
            position: 'absolute',
            right: '16px',
        },
        '&.Mui-disabled': {
            opacity: 0.4,
        },
    },
    leftButton: {
        '&.MuiIconButton-root': {
            position: 'absolute',
            left: '16px',
        },
        '&.Mui-disabled': {
            opacity: 0.4,
        },
    },
}));
